// import config from 'config';
import {authHeader, isUserOnline} from '../_helpers';

export const userService = {
    login,
    logout,
    register,
    getAll,
    getById,
    update,
    delete: _delete
};

function login(username, password) {
    console.log("Login User Service");

    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password })
    };

    return fetch(`https://localhost:9000/users/authenticate`, requestOptions)
        .then(handleResponse)
        .then(user => {
            console.log("Fetch called and getting result");

            // login successful if there's a jwt token in the response
            if (user.token) {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('user', JSON.stringify(user));
            }

            return user;
        });
}

function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('user');
}

function register(user) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(user)
    };

    return fetch(`https://localhost:9000/users/register`, requestOptions).then(handleResponse);
}

function getAll() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(`https://localhost:9000/users`, requestOptions).then(handleResponse);
}


function getById(id) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(`https://localhost:9000//users/${id}`, requestOptions).then(handleResponse);
}

function update(user) {
    const requestOptions = {
        method: 'PUT',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(user)
    };

    // return fetch(`https://localhost:9000/users/${user.id}`, requestOptions).then(handleResponse);
    console.log('User update is called with the URL : ' + `https://testoffline.spordle.com/API/account.php?id=${user.id}`);
    console.log('Request options : ' + JSON.stringify(requestOptions));

    fetch(`https://testoffline.spordle.com/API/account.php?id=${user.id}`, requestOptions)
        .then(
            function (response) {
                console.log(response);
            }
        )
        .catch(function (e) {
            console.log('e : ' + e);
        });

    return fetch(`https://testoffline.spordle.com/API/account.php?id=${user.id}`, requestOptions).then(handleResponse);;
}

// prefixed function name with underscore because delete is a reserved word in javascript
function _delete(id) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader()
    };

    return fetch(`https://localhost:9000/users/${id}`, requestOptions).then(handleResponse);
}

function handleResponse(response) {
    console.log('Response : ' + response);

    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
                location.reload(true);
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }



        return data;
    });
}
